export const getQueryStringValue = (searchString, key) => {
  const searchParams = new URLSearchParams(searchString);
  return searchParams.get(key);
};

export const removeQueryStringFromUrl = (location, key) => {
  const searchParams = new URLSearchParams(location.search);
  const url = location.href.split('?');

  searchParams.delete(key);

  return `${url[0]}${
    searchParams.toString() ? '?' : ''
  }${searchParams.toString()}`;
};

export const hasQueryStringParam = (searchString, key) => {
  const searchParams = new URLSearchParams(searchString);
  return searchParams.has(key);
};
